export function getDataTableApi(innerElement) {
	return $(innerElement).closest('.dataTables_wrapper').find('.dataTable:first').DataTable();
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/utils.js